import { outter_post_newUrl, outter_post, post } from 'common/js/axios-helper';
import { YiSheng } from "./constant/UrlMapper";

const host = '8885';
const host2 = '8883';
const host3 = '8880';
const host4 = '8889';
// 查询列表
const YiShengList = (data) => {
    return post(YiSheng.YiShengList, data, host2);
}

// 进件

const joinYisheng = (data) => {
    return post(YiSheng.YishengJoin, data, host2);
}

// 签约

const  Agency = (data) => {
    return post(YiSheng.YishengAudit, data, host2);
}

// 查询页

const  getListOne = (data) => {
    return post(YiSheng.YishengChildOne, data, host2);
}

// 查询页

const  getListTwo = (data) => {
    return post(YiSheng.YishengChildTwo, data, host2);
}

// 查询页

const  getListThree = (data) => {
    return post(YiSheng.YishengChildThree, data, host2);
}

// 查询页

const  getListFour = (data) => {
    return post(YiSheng.YishengChildFour, data, host2);
}

 // 查询页

const  getListFive = (data) => {
    return post(YiSheng.YishengChildFive, data, host2);
}

// 审核页
const  getText = (data) => {
    return post(YiSheng.yishengText, data, host2);
}

// 商户费率页面
const  getMoneyList = (data) => {
    return post(YiSheng.yishengMoney, data, host);
}

// 新增子页面多模块执照
const  getAddList = (data) => {
    return post(YiSheng.yishengAdd, data, host2);
}
// 子页面修改信息
const changeBase = (data) => {
    return post(YiSheng.yishengBase, data, host2)
}
const changeOpen = (data) => {
    return post(YiSheng.yishengOpen, data, host2)
}
const changeMoney = (data) => {
    return post(YiSheng.yishengMoney, data, host2)
}

const seeNewData = (data) => {
    return post(YiSheng.yishengNew, data, host2)
}
const toEdit = (data) => {
    return post(YiSheng.toEdit, data, host2)
}
export default {
    YiShengList,
    joinYisheng,
    Agency,
    getListOne,
    getListTwo,
    getListThree,
    getListFour,
    getListFive,
    getText,
    getMoneyList,
    getAddList,
    changeBase,
    changeOpen,
    changeMoney,
    seeNewData,
    toEdit
}


// WEBPACK FOOTER //
// ./src/service/AyiSheng.js